import { render, staticRenderFns } from "./PricerData.vue?vue&type=template&id=b5898fd2&scoped=true"
import script from "./PricerData.vue?vue&type=script&lang=js"
export * from "./PricerData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5898fd2",
  null
  
)

export default component.exports